import { Box, Typography } from '@mui/material';
import { EmployeeListItem } from '@pxtra-client-lib-legacy/gen';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from '../../../lib/components';
import Util from '../../../misc/util';
import { useNavigate } from 'react-router';
import { env } from '../../../lib/env';

type Props = {
  id: EmployeeListItem['id'];
  first_name: EmployeeListItem['first_name'];
  last_name: EmployeeListItem['last_name'];
  profile_picture: EmployeeListItem['profile_picture'];
  birth_date?: EmployeeListItem['birth_date'];
  position_name: EmployeeListItem['position_name'];
  entry_date?: EmployeeListItem['entry_date'];
};

export const EmployeeDashboardListItem: FC<Props> = ({
  id,
  first_name,
  last_name,
  profile_picture,
  birth_date,
  position_name,
  entry_date
}) => {
  const navigate = useNavigate();
  const isBirthday = !!birth_date;
  const { t } = useTranslation();

  let nextBirthday = '',
    age = '',
    nextAnniversary = '',
    anniversary = '';

  if (isBirthday) {
    nextBirthday = Util.calcNextYearlyDate(birth_date as string);
    age = Util.formatAge(birth_date as string, t);
  } else {
    nextAnniversary = Util.calcNextYearlyDate(entry_date as string);
    anniversary = Util.formatAge(entry_date as string, t);
  }

  const firstLine = isBirthday ? age : anniversary;
  const secondLine = isBirthday ? nextBirthday : nextAnniversary;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '0.75rem',
        padding: '0.5rem',
        borderRadius: '0.75rem',
        '&:hover': {
          backgroundColor: 'grey.50',
          cursor: 'pointer'
        }
      }}
      onClick={() => navigate(`/employees/${id}/dashboard`)}
    >
      <Avatar
        className="bg-white"
        src={`${env('API_BASE_URL')}${profile_picture}`}
        initials={`${first_name && first_name?.slice(0, 1)}${last_name && last_name?.slice(0, 1)}`}
        imgProps={{
          style: { objectFit: 'contain' }
        }}
      />
      <Box margin="auto 0" flexGrow={1}>
        <Typography component="span" variant="subtitle1" lineHeight="1rem">
          {first_name} {last_name}
        </Typography>
        <Typography variant="body2" lineHeight="1rem">
          {position_name}
        </Typography>
      </Box>
      <Box margin="auto" width="6.5rem" textAlign="right">
        <Typography component="span" variant="subtitle1" lineHeight="1rem">
          {firstLine}
        </Typography>
        <Typography variant="body2" lineHeight="1rem">
          {secondLine}
        </Typography>
      </Box>
    </Box>
  );
};
